/**
 * Datos fijos de la tienda.
 *
 * Estan en un solo lugar porque se repiten en la cabecera, el pie, los enlaces
 * de WhatsApp y los datos estructurados: si el telefono cambia, cambia aca.
 *
 * SUPUESTOS que el cliente tiene que confirmar: la direccion de la sala de
 * ventas (el sitio anterior solo decia "Pucon") y el horario de atencion, que
 * no estaba publicado en ninguna parte. El correo, el WhatsApp, las redes y la
 * ficha de Google Maps si son los que entrego el cliente.
 *
 * Lo que NO va aca son las condiciones de despacho: el monto de despacho gratis
 * y las tarifas por region las administra el backoffice (ADM-10) y llegan por
 * `contexto/despacho.tsx`. Escribirlas aca era garantizar que el panel y la
 * tienda dijeran cosas distintas.
 */

export const SITIO = {
  nombre: 'Bandu',
  nombreLargo: 'Bandu Store',
  /** La promesa de la marca, en una linea. Va en la portada y en las cabeceras de respaldo. */
  lema: 'Equipamiento outdoor probado en los ríos del sur de Chile',
  descripcion:
    'Equipo de rafting, kayak y campamento base: trajes de neopreno, chalecos, cascos, balsas, packrafts y carpas. Stock real y pago en línea.',
  /** Base de las URL canonicas. En produccion la fija la variable de entorno. */
  urlBase: import.meta.env.VITE_URL_SITIO ?? 'https://banduchile.cl',
  direccion: {
    calle: 'Bandu Store',
    comuna: 'Pucón',
    region: 'Región de La Araucanía',
    pais: 'CL',
  },
  /**
   * Identificador de la ficha del negocio en Google Maps (CID).
   *
   * Apunta a la ficha de "BANDU STORE", no a una busqueda por direccion: quien
   * pulsa el mapa llega a la tienda con sus horarios, sus fotos y sus resenas,
   * no a un punto en una calle.
   *
   * Es el numero que Google usa internamente para el local, y sale del par
   * `!1s0x0:0x598a59ff83af608a` de la URL de la ficha, pasado a decimal. Se
   * guarda asi, y no la URL larga que copia el navegador, porque esa arrastra
   * parametros de sesion (`sa`, `ved`, `ictx`) que Google rota y que quedarian
   * congelados en el codigo. De aca salen tanto el mapa embebido como el enlace
   * del pie.
   */
  mapaCid: '6452068370122498186',
  /** El negocio atiende por celular: el telefono y el WhatsApp son el mismo numero. */
  telefono: '+56 9 3866 0742',
  email: 'banduraft@gmail.com',
  whatsapp: '56938660742',
  whatsappVisible: '+56 9 3866 0742',
  horario: 'Escríbenos por WhatsApp para coordinar tu visita',
  redes: {
    instagram: 'https://www.instagram.com/bandu.cl/',
    facebook: 'https://www.facebook.com/profile.php?id=100089039992598',
  },
} as const;
